import React from 'react';
import ReactLoading from 'react-loading';
import {
  Timeline as ChartIcon,
  Remove as RemoveIcon,
  Add as AddIcon,
  Lens as CircleIcon,
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Constants from '../../../../../constants/Constants';

const iconStyle = {
  width: '1rem',
  height: '1rem',
};

const alertIconStyle = {
  width: '1rem',
  height: '1rem',
  marginTop: '6px',
};

const overallAlertIconStyle = {
  width: '1.5rem',
  height: '1.5rem',
  marginTop: '6px',
};

export const markupMap = (props) => [
  {
    key: 'expandable',
    markup: (el, col, elIndex, colIndex) => {
      return el.Subreport ? (
        el.Subreport.isFetching ? (
          <ReactLoading type="bubbles" color="#34495e" style={iconStyle} />
        ) : el.Subreport.clicked ? (
          <RemoveIcon key={1} style={iconStyle} data-qa="qa-row-colapse" />
        ) : (
          <AddIcon key={2} style={iconStyle} data-qa="qa-row-expand" />
        )
      ) : null;
    },
  },
  {
    key: 'SubreportDialog',
    markup: (el, col, elIndex, colIndex) => {
      return el.SubreportDialogArguments ? (
        <IconButton
          size="large"
          onClick={(e) => {
            e.stopPropagation();
            const params = {
              el: el,
              supreportDialogArguments: el.SubreportDialogArguments,
            };
            return props.onReportItemEvent(params, 'subreportDialog');
          }}
          style={{
            width: 'auto',
            height: 'auto',
            padding: 0,
          }}
          disabled={props.isFetching}
          data-qa="qa-chart-button"
        >
          <ChartIcon />
        </IconButton>
      ) : null;
    },
  },
  {
    key: 'formatJson',
    markup: (el, col, elIndex, colIndex) => {
      if (el.FormatJsonContent != undefined) {
        let value = el.FormatJsonContent;

        if (typeof value !== 'string' || value[0] !== '{') {
          return <div>{value}</div>;
        }

        let entity = JSON.parse(value);
        let listItems = Object.keys(entity).map((key) => {
          return (
            <li>
              {key} = {JSON.stringify(entity[key])}
            </li>
          );
        });

        return (
          <div>
            <ul>{listItems}</ul>
          </div>
        );
      } else {
        return null;
      }
    },
  },
  {
    key: 'ConnectionAlert.Level',
    markup: (el, col, elIndex, colIndex) => {
      var style = { ...alertIconStyle };
      style.color = el.ConnectionAlert ? el.ConnectionAlert.Color : Constants.COLORS.NEUTRAL;
      return <CircleIcon key={1} style={style} fill={style.color} />;
    },
  },
  {
    key: 'StatusAlert.Level',
    markup: (el, col, elIndex, colIndex) => {
      var style = { ...alertIconStyle };
      style.color = el.StatusAlert ? el.StatusAlert.Color : Constants.COLORS.NEUTRAL;
      return <CircleIcon key={1} style={style} fill={style.color} />;
    },
  },
  {
    key: 'OverallAlert.Level',
    markup: (el, col, elIndex, colIndex) => {
      var style = { ...overallAlertIconStyle };
      style.color = el.OverallAlert ? el.OverallAlert.Color : Constants.COLORS.NEUTRAL;
      return <CircleIcon key={1} style={style} fill={style.color} />;
    },
  },
];
